














import Vue from "vue";
import {Component} from "vue-property-decorator";
@Component({
    components: {},
    props: {
        gameIsPaused: {
            type: Boolean,
        },
    }
})

export default class GamePaused extends Vue {
    /**
     * Продолжить игру
     */
    private continueGame(): void {
        this.$emit('continue-game');
        this.$emit('hide-paused-overlay')
    }
}
